
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cDMVr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89615b8031d999fa51e8e6558441c313>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $933f141c99b2ec32$var$_react = $933f141c99b2ec32$var$_interopRequireDefault((parcelRequire("42omo")));

var $933f141c99b2ec32$var$_baseNew = $933f141c99b2ec32$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $933f141c99b2ec32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $933f141c99b2ec32$var$PersonAddIcon = (props)=>/*#__PURE__*/ $933f141c99b2ec32$var$_react.default.createElement($933f141c99b2ec32$var$_baseNew.default, Object.assign({
        name: "PersonAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$933f141c99b2ec32$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $933f141c99b2ec32$var$_default = module.exports.default = $933f141c99b2ec32$var$PersonAddIcon;

});


//# sourceMappingURL=person-add.2ade7731.js.map
